var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:[
        'ui-list',
        `--${_setup.props.size}`,
    ]},[_c('h4',{staticClass:"ui-list__title"},[_vm._t("title",function(){return [_vm._v(" "+_vm._s(_setup.props.title)+" ")]})],2),_c('ul',{staticClass:"ui-list__list",style:({
            '--ui-list-columns': _setup.columnsFormat(_setup.props.columns),
            '--ui-list-gap': _setup.spaceFormat(_setup.props.space),
        })},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }